import styled from 'styled-components';
import { themeGet } from 'styled-system';

import { CenteredFlex } from '@src/features/common';

export const TabWrapper = styled(CenteredFlex)<{
  index: number;
  activeIndex: number;
}>`
  position: relative;
  height: 40px;
  padding: 12px 14px;
  border-radius: 4px;
  text-align: center;
  color: ${themeGet('colors.textPrimary')};
  font-size: 16px;

  &:hover {
    background: #e3effe8c;
  }
`;
